<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
		className?: string;
	}

	let { config, className = '' }: Props = $props();
</script>

<div class="features {className}">
	<div class="container">
		<h2>Why Choose {config.displayName}?</h2>
		<div class="features-grid">
			{#if config.features && config.features.length > 0}
				{#each config.features as feature}
					<div class="feature">
						<h3>{feature.title}</h3>
						<p>{feature.description}</p>
					</div>
				{/each}
			{:else}
				<!-- Fallback features if not configured -->
				<div class="feature">
					<h3>Proven Results</h3>
					<p>Our methods have been tested and refined through real-world applications.</p>
				</div>
				<div class="feature">
					<h3>Expert Guidance</h3>
					<p>Learn from industry professionals who have walked the path before you.</p>
				</div>
				<div class="feature">
					<h3>Community Support</h3>
					<p>Join a community of like-minded individuals on similar journeys.</p>
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
	.features {
		padding: 2rem 0;
		width: 100%;
	}

	.container {
		width: 100%;
		padding: 0;
	}

	.features h2 {
		text-align: center;
		font-size: 2.5rem;
		margin-bottom: 3rem;
		color: var(--brand-primary);
	}

	.features-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 2rem;
	}

	.feature {
		background: var(--color--background-secondary, white);
		padding: 2rem;
		border-radius: 12px;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
		text-align: center;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		border: 1px solid var(--color--accent, transparent);
	}

	.feature:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
		border-color: var(--color--accent, var(--brand-secondary));
	}

	.feature h3 {
		font-size: 1.5rem;
		margin-bottom: 1rem;
		color: var(--brand-primary);
	}

	.feature p {
		color: var(--color--text-secondary, #64748b);
		line-height: 1.6;
	}
</style>
